import { Flex } from "antd";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { AiFitAnalysis } from "../lib/aiFitCheckUtils";
import { BadgeList, BulletList } from "./parts";
import styles from "./styles.module.scss";

export function OverviewTab({ data }: { data: AiFitAnalysis }) {
  const fit = data.creator_campaign_fit;
  const decision = data.final_decision_context;
  const reasons = data.fit_reasons;
  const highlights = data.frontend_highlights;

  return (
    <Flex vertical gap={20}>
      {fit?.frontend_summary ? (
        <div className={styles.panel}>
          <p className={styles.summaryText}>{fit.frontend_summary}</p>
        </div>
      ) : null}

      {decision ? (
        <div
          className={`${styles.panel} ${
            decision.should_brand_shortlist ? styles.panelSuccess : ""
          }`}
        >
          <Flex
            wrap="wrap"
            align="center"
            gap={8}
            className={styles.decisionHead}
          >
            <span className={styles.decisionTitle}>
              {decision.should_brand_shortlist
                ? "Recommended to shortlist"
                : "Not recommended to shortlist"}
            </span>
            {decision.confidence ? (
              <span className={styles.decisionConfidence}>
                {decision.confidence} confidence
              </span>
            ) : null}
          </Flex>
          {decision.decision_reason ? (
            <p className={styles.bodyText}>{decision.decision_reason}</p>
          ) : null}
          {decision.what_to_check_manually?.length ? (
            <div className={styles.decisionFooter}>
              <p className={styles.miniLabel}>Check manually</p>
              <BulletList items={decision.what_to_check_manually} />
            </div>
          ) : null}
        </div>
      ) : null}

      <div className={styles.twoCol}>
        <div className={styles.panel}>
          <h3 className={styles.panelTitle}>
            <CheckCircle2 size={14} className={styles.iconMatch} />
            Top match reasons
          </h3>
          <BulletList items={reasons?.top_match_reasons} />
        </div>
        <div className={styles.panel}>
          <h3 className={styles.panelTitle}>
            <AlertTriangle size={14} className={styles.iconMismatch} />
            Top mismatch reasons
          </h3>
          <BulletList items={reasons?.top_mismatch_reasons} />
        </div>
      </div>

      <div className={styles.panel}>
        <h3 className={styles.panelTitle}>Highlights</h3>
        <Flex vertical gap={12}>
          <div>
            <p className={styles.miniLabel}>Positive</p>
            <BadgeList items={highlights?.positive_badges} variant="positive" />
          </div>
          <div>
            <p className={styles.miniLabel}>Warnings</p>
            <BadgeList items={highlights?.warning_badges} variant="warning" />
          </div>
          <div>
            <p className={styles.miniLabel}>Best fit</p>
            <BadgeList items={highlights?.best_fit_labels} variant="fit" />
          </div>
          <div>
            <p className={styles.miniLabel}>Not fit</p>
            <BadgeList items={highlights?.not_fit_labels} variant="not-fit" />
          </div>
        </Flex>
      </div>
    </Flex>
  );
}
